<template>
  <div
    class="flex justify-between border shadow border-gray-300 rounded-sm hover:border-gray-400 group bg-white"
  >
    <div class="flex flex-1 items-center">
      <div class="w-24 h-24 p-4 flex items-center">
        <a :href="profileUrl" target="_new">
          <img
            v-if="startup.logo_url"
            class="object-scale-down"
            :src="startup.logo_url | cld({ h: 90, w: 150, c: 'limit' })"
            alt=""
          />
        </a>
      </div>
      <div v-if="true" class="flex-1 flex flex-col m-2">
        <div class="flex-1">
          <a
            class="pb-2 text-gray-500 font-semibold text-sm"
            :href="profileUrl"
            target="_new"
          >
            {{ startup.name }}
          </a>
        </div>
        <div class="flex flex-1 items-center py-2 text-sm">
          <p class="text-gray-400 m-0">
            <ion-icon name="location-outline" />
            {{ getLocationForStartup(startup) }}
          </p>
          <span class="mx-3 text-gray-400">|</span>
          <div class="flex">
            <span class="text-gray-400 mr-3">
              {{ getStageLabel(startup.stage) }}
            </span>

            <ProductStageMeter
              class="flex-1"
              :stage="startup.stage"
              :show-label="false"
            />
          </div>
        </div>
        <div class="flex justify-start">
          <Tag v-for="(sector, idx) in sectors" :key="idx" class="text-xs mr-1">
            {{ sector }}
          </Tag>
        </div>
      </div>
      <div
        v-if="showStandardActions"
        class="flex justify-start flex-col md:flex-row-reverse m-2"
      >
        <ShortlistStartup
          v-if="user.isInvestorOrOrganizer"
          :startup="startup"
          :org-id="user.organizationId"
          @update="onShortlistsUpdate"
        />
        <div class="w-2"></div>
        <ConnectWithStartup
          v-if="user.isInvestorOrOrganizer"
          :startup="startup"
          :org-id="user.organizationId"
        />
      </div>

      <template v-if="false">
        <div class="flex-1 flex flex-col justify-start">
          <a
            class="pb-2 text-gray-400 font-semibold"
            :href="getProfileUrl()"
            target="_new"
          >
            {{ startup.name }}
          </a>
          <p class="text-gray-400">
            <ion-icon name="location-outline" />
            {{ getLocationForStartup(startup) }}
          </p>
          <span>{{ getSectorsText(startup) }}</span>
        </div>
        <div class="flex-1">
          <p class="text-gray-400 text-sm">
            <ion-icon name="location-outline" />
            {{ getLocationForStartup(startup) }}
          </p>
        </div>
      </template>
    </div>
    <div class="actions">
      <slot name="actions" :startup="startup"></slot>
    </div>
  </div>
</template>

<script>
import router from 'routes'
import { getSectorsText, getLocationForStartup } from '@/services/startup'
import { getStageLabel } from '@/services/startup-stages'
import { sectorLabel } from 'services/sectors'
import useUser from 'states/useUser'
import ProductStageMeter from '@/components/ProductStageMeter'
import ConnectWithStartup from 'components/organizations/ConnectWithStartup'
import AddToShortlist from 'components/startups/AddToShortlist'
import ShortlistStartup from 'components/organizations/ShortlistStartup/ShortlistStartup.vue'
import Tag from '@/components/common/Tag'
import { computed } from '@vue/composition-api'

export default {
  components: {
    AddToShortlist,
    ConnectWithStartup,
    ProductStageMeter,
    ShortlistStartup,
    Tag,
  },
  props: {
    startup: {
      type: Object,
      default: () => ({}),
    },
    showStandardActions: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const getProfileUrl = () => {
      const { startup } = props
      return router.resolve({
        name: 'publicStartupProfile',
        params: { slug: startup.id },
      }).href
    }
    const profileUrl = computed(() => {
      const { startup } = props
      return router.resolve({
        name: 'publicStartupProfile',
        params: { slug: startup.id },
      }).href
    })
    const { user } = useUser()

    const onShortlistsUpdate = ({ shortlists }) => {
      emit('update', { shortlists })
    }

    const sectors = computed(() => {
      return (props.startup.sectors || []).map((s) => sectorLabel(s))
    })

    return {
      getLocationForStartup,
      getSectorsText,
      getProfileUrl,
      getStageLabel,
      user,
      onShortlistsUpdate,
      sectors,
      profileUrl,
    }
  },
}
</script>
